class VideoSlider extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            direction: 'horizontal',
            slidesPerView: "auto",
            loop: false,
            threshold: 10,
        });

        this.querySelectorAll('.video-container svg').forEach((elem) => {
            elem.addEventListener('click', function (e) {
                let videoElement = e.currentTarget.closest('.video-container').querySelector('.myVideo');
                let videoElementSvg = e.currentTarget.closest('.video-container').querySelector('svg');
                videoElementSvg.style.display = 'none';
                videoElement.setAttribute('playsinline', 'playsinline');
                videoElement.setAttribute('controls', 'controls');
                videoElement.play();
            });
        });
    }
}

customElements.define('video-slider', VideoSlider);